var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_2683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 0.0107422C12.0645 1.65994 12.9518 3.4692 13.5588 5.37919C14.9476 5.16132 16.2852 4.69274 17.5064 3.99638L17.8648 3.77414C16.1647 1.62251 13.6565 0.262212 10.9258 0.0107422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5091 6.98926C11.6762 7.08465 10.8385 7.13253 10.0001 7.13261C9.16177 7.13249 8.32411 7.08465 7.4912 6.98926C7.31424 7.743 7.20155 8.51039 7.1543 9.28315H12.846C12.7988 8.51039 12.686 7.743 12.5091 6.98926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 14.3008C9.29413 14.3014 8.58832 14.338 7.88574 14.4104C8.40259 15.9538 9.11319 17.4252 10.0005 18.7896C10.8877 17.4252 11.5983 15.9537 12.1152 14.4104C11.4126 14.338 10.7068 14.3014 10.0005 14.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2736 10.7168C14.2299 11.5626 14.1155 12.4033 13.9316 13.2301C15.4579 13.4836 16.9257 14.0111 18.2643 14.7871L18.6693 15.0394C19.4381 13.7195 19.8933 12.2406 19.9998 10.7168H14.2736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6693 4.96094L18.2643 5.21329C16.926 5.99051 15.4581 6.5192 13.9316 6.77386C14.1153 7.59921 14.2296 8.43842 14.2736 9.2828H19.9998C19.8932 7.75928 19.438 6.28066 18.6693 4.96094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1543 10.7168C7.20197 11.4896 7.31517 12.257 7.49263 13.0107C9.15984 12.8203 10.8433 12.8203 12.5106 13.0107C12.687 12.2569 12.7993 11.4895 12.846 10.7168H7.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73547 5.21329L1.33044 4.96094C0.561786 6.28066 0.106603 7.75928 0 9.2828H5.72618C5.77012 8.43842 5.88449 7.59917 6.06813 6.77386C4.54163 6.5192 3.07376 5.99051 1.73547 5.21329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44182 14.6211C5.05312 14.839 3.71555 15.3073 2.49415 16.0032L2.13574 16.2261C3.83576 18.3779 6.34408 19.738 9.0748 19.9889C7.93594 18.34 7.04859 16.531 6.44182 14.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 1.21094C9.11331 2.57518 8.40275 4.04641 7.88574 5.58942C8.58828 5.66226 9.29413 5.69884 10.0005 5.69909C10.7068 5.69884 11.4126 5.66221 12.1152 5.58942C11.5981 4.04641 10.8876 2.57518 10.0005 1.21094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5066 16.0032C16.2852 15.3074 14.9476 14.8391 13.5589 14.6211C12.9515 16.5311 12.0634 18.3401 10.9238 19.9888C13.6546 19.7379 16.1629 18.3778 17.8629 16.2261L17.5066 16.0032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1377 3.77414L2.49396 3.99638C3.71519 4.69274 5.05281 5.16128 6.44163 5.37919C7.0492 3.46903 7.9373 1.65981 9.07675 0.0107422C6.34603 0.26217 3.83788 1.62247 2.1377 3.77414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72618 10.7168H0C0.106477 12.2406 0.56166 13.7195 1.33048 15.0394L1.73551 14.7871C3.07405 14.0111 4.54188 13.4836 6.06813 13.2301C5.8842 12.4033 5.76982 11.5626 5.72618 10.7168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_2683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGobal);
export default __webpack_public_path__ + "static/media/gobal.e9e4d02bc440b323b20809a965c6a4bb.svg";
export { ForwardRef as ReactComponent };